import { mutateApi, queryApi } from "src/utils/api/ApiMethods"

export const getJobActivity = (marinaSlug, jobId, { beforeCursor } = {}) => {
  const params = new URLSearchParams()
  if (beforeCursor) params.set("before_cursor", beforeCursor)
  const query = params.toString()
  const suffix = query ? `?${query}` : ""
  return queryApi(
    `/manage/${marinaSlug}/service/jobs/${jobId}/activity.json${suffix}`
  )
}

export const postJobActivityNote = (marinaSlug, jobId, { body }) =>
  mutateApi({
    url: `/manage/${marinaSlug}/service/jobs/${jobId}/activity.json`,
    method: "POST",
    data: { note: { body } },
  })
